import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelComponent } from './panel/panel.component';
import { DialogsModule } from '../dialogs/dialogs.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PanelComponent],
  imports: [
    TooltipModule,
    CommonModule,
    DialogsModule,
    MatIconModule
  ],
  exports: [PanelComponent]
})
export class PanelsModule { }
